export default "__VITE_ASSET__Db6z4lX$__"